export default "__VITE_ASSET__B6Wt0lNc__"